import { Wifi, WifiOff } from '@untitledui/icons';
import {
  Connected,
  Connecting,
  ConnectionError,
  Disconnected,
  type ConnectionState
} from '../../../types/general/connectionState';
import { en } from '../../../locales/en';
import { Icon } from '../../../components/general/Icon';

interface ConnectionStatusIconProps {
  connectionState: ConnectionState;
  size?: number;
}

const heartbeatStyles = `
  @keyframes heartbeat {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
  }
  
  .connection-status-heartbeat {
    animation: heartbeat 1.2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  }
`;

function ConnectionStatusIcon({ connectionState, size }: ConnectionStatusIconProps) {
  const getConnectionStateTitle = () => {
    if (connectionState instanceof Connected) {
      return en.connectionStatusTitles.connected;
    } else if (connectionState instanceof Connecting) {
      return en.connectionStatusTitles.connecting;
    } else if (connectionState instanceof ConnectionError) {
      return en.connectionStatusTitles.connectionError;
    } else if (connectionState instanceof Disconnected) {
      return en.connectionStatusTitles.disconnected;
    }
    return en.connectionStatusTitles.disconnected;
  };

  const getIconAndColor = (connectionStatus: ConnectionState) => {
    if (connectionStatus instanceof Connected) {
      return { icon: Wifi, color: 'var(--color-green)' };
    }
    if (connectionStatus instanceof Connecting) {
      return { icon: WifiOff, color: 'var(--color-orange)' };
    }
    if (connectionStatus instanceof Disconnected || connectionStatus instanceof ConnectionError) {
      return { icon: WifiOff, color: 'var(--color-red)' };
    }
    return { icon: WifiOff, color: 'var(--color-red)' };
  };

  const { icon, color } = getIconAndColor(connectionState);
  const isConnecting = connectionState instanceof Connecting;

  return (
    <div style={{ padding: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <style>{heartbeatStyles}</style>
      <Icon
        icon={icon}
        size={size}
        color={color}
        className={isConnecting ? 'connection-status-heartbeat' : undefined}
        title={getConnectionStateTitle()}
      />
    </div>
  );
}

export default ConnectionStatusIcon;
